"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useIsMobileState = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _lodash = require("lodash");
var _react = require("react");
/**
 * 与 tci-ui 组件库的移动端判定方式保持一致
 * config-solution 建议都用这个
 */
const useIsMobileState = () => {
  const _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    isMobile = _useState2[0],
    setIsMobile = _useState2[1];
  const checkChange = (0, _lodash.throttle)(() => {
    const winWidth = document.documentElement.offsetWidth || document.body.offsetWidth;
    if (winWidth <= 768) {
      setIsMobile(true);
    } else {
      setIsMobile(false);
    }
  }, 50);
  (0, _react.useEffect)(() => {
    checkChange();
    window.addEventListener('resize', checkChange);
    return () => {
      window.removeEventListener('resize', checkChange);
    };
  }, []);
  return [isMobile, setIsMobile];
};
exports.useIsMobileState = useIsMobileState;